/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 *        佛曰:
 *                写字楼里写字间，写字间里程序员；
 *                程序人员写程序，又拿程序换酒钱。
 *                酒醒只在网上坐，酒醉还来网下眠；
 *                酒醉酒醒日复日，网上网下年复年。
 *                但愿老死电脑间，不愿鞠躬老板前；
 *                奔驰宝马贵者趣，公交自行程序员。
 *                别人笑我忒疯癫，我笑自己命太贱；
 *                不见满街漂亮妹，哪个归得程序员？
 *
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-09-02 09:38:52
 * @LastEditTime: 2021-09-15 11:01:46
 * @FilePath: \uniapp-npm\lushh-services\index.js
 * @Description:
 */

import { lushhHttp, setConfig as lushhHttpSetConfig } from 'lushh-request'
import lushhHttpConfig from './lushhHttpConfig.js'
import api from './lib/lushh-services.esm.js'
try {
  lushhHttpSetConfig(lushhHttpConfig)
} catch (error) {
  console.log(error)
}
const install = (Vue) => {
  Vue.prototype.$lushhHttp = lushhHttp
  Vue.prototype.$api = api
}
export default { install }
